// Loaded for logged-out customers only. Redirects any add-to-cart click to login.
(function () {
  // ATC triggers: buy buttons, quick-add, bulk order add.
  var TRIGGERS = '[name="add"], .js-quick-add, [data-bulk-order-add]';

  function loginUrl() {
    return (window.theme && window.theme.routes && window.theme.routes.accountLoginUrl) || '/account/login';
  }

  // Capture phase: run before the theme's own submit/click handlers.
  document.addEventListener(
    'click',
    function (evt) {
      if (!evt.target.closest(TRIGGERS)) return;
      evt.preventDefault();
      evt.stopImmediatePropagation();
      window.location.href = loginUrl();
    },
    true
  );
})();
